import React from "react";
import { Navigate } from "react-router-dom";

// Moondance Pages (lazy-loaded for route-based code splitting)
const MoonDanceDashboard = React.lazy(() => import("../moondance/pages/dashboard"));
const PositionDetail = React.lazy(() => import("../moondance/pages/position_detail"));
const AddPosition = React.lazy(() => import("../moondance/pages/position_add_page.js"));
const EditPosition = React.lazy(() => import("../moondance/pages/position_edit.js"));
const EditModel = React.lazy(() => import("../moondance/pages/position_edit_model.js"));
const DuplicatePosition = React.lazy(() => import("../moondance/pages/position_duplicate.js"));
const Transactions = React.lazy(() => import("../moondance/pages/transactions_list.js"));
const AddTransaction = React.lazy(() => import("../moondance/pages/transactions_add_page.js"));
const AddFile = React.lazy(() => import("../moondance/pages/files/addFile.js"));
const EditFile = React.lazy(() => import("../moondance/pages/files/editFile.js"));
const UpdateNav = React.lazy(() => import("../moondance/pages/nav_update_page.js"));
const NavBulk = React.lazy(() => import("../moondance/pages/nav_update_bulk.js"));
const Logs = React.lazy(() => import("../moondance/pages/logs.js"));
const Notes = React.lazy(() => import("../moondance/pages/notes_list.js"));
const AddNotes = React.lazy(() => import("../moondance/pages/notes_add.js"));
const EditNotes = React.lazy(() => import("../moondance/pages/notes_edit.js"));
const Contact = React.lazy(() => import("../moondance/pages/contact.js"));
const ImportXls = React.lazy(() => import("../moondance/pages/import/import.js"));
const ExchangeRatesHistory = React.lazy(() => import("../moondance/pages/exchange_rate.js"));
const PdfReport = React.lazy(() => import("../moondance/pages/report.js"));
const Export = React.lazy(() => import("../moondance/pages/export.js"));

// Moondance Profile Pages
const UserProfile = React.lazy(() => import("../moondance/profile/userProfile"));
const Accounts = React.lazy(() => import("../moondance/profile/accounts"));
const SelectAccount = React.lazy(() => import("../moondance/pages/account_select.js"));

// Moondance Admin Pages
const MoonBase = React.lazy(() => import("../moondance/admin/index.js"));
const Users = React.lazy(() => import("../moondance/admin/users.js"));
const Clients = React.lazy(() => import("../moondance/admin/clients.js"));

// Moondance Authentication Pages
const MoondanceLogin = React.lazy(() => import("../moondance/login/login"));
const MoondanceLostPassword = React.lazy(() => import("../moondance/login/lostPassword"));
const MoondanceResetPassword = React.lazy(() => import("../moondance/login/resetPassword"));
const MoondanceRegister = React.lazy(() => import("../moondance/login/register"));
const ConfirmSignup = React.lazy(() => import("../moondance/login/confirm-signup"));
const Logout = React.lazy(() => import("../Pages/Authentication/Logout"));

// Public Website Pages
const PublicWebsite = React.lazy(() => import("../moondance/publicWebsite/index.js"));
const PublicServices = React.lazy(() => import("../moondance/publicWebsite/services.js"));
const GeneralSalesConditions = React.lazy(() => import("../moondance/publicWebsite/gsc.js"));
const ConfirmContactForm = React.lazy(() => import("../moondance/publicWebsite/confirmContactForm.js"));
const PublicContactForm = React.lazy(() => import("../moondance/publicWebsite/publicContactForm.js"));

/*
 * Define routes that are protected by authentication
 * These routes will only be accessible after the user is authenticated
 */
const authProtectedRoutes = [
  // Dashboard and Position Pages
  { path: "/dashboard", component: <MoonDanceDashboard /> },
  { path: "/dashboard/:id", component: <MoonDanceDashboard /> },
  { path: "/position/:id", component: <PositionDetail /> },
  { path: "/addPosition", component: <AddPosition /> },
  { path: "/duplicatePosition/:id", component: <DuplicatePosition /> },
  
  // Transactions and Nav Pages
  { path: "/addTransaction", component: <AddTransaction /> },
  { path: "/addTransaction/:id", component: <AddTransaction /> },
  { path: "/addNav", component: <UpdateNav /> },
  { path: "/navbulk", component: <NavBulk /> },

  //Exchange Rate Pages
  { path: "/exchangeRatesHistory", component: <ExchangeRatesHistory /> },

  // Editing Pages
  { path: "/editPosition/:id", component: <EditPosition /> },
  { path: "/editModel/:id", component: <EditModel /> },
  
  // Logs and Notes Pages
  { path: "/logs", component: <Logs /> },
  { path: "/notes", component: <Notes /> },
  { path: "/notes/new/:id", component: <AddNotes /> },
  { path: "/notes/edit/:id", component: <EditNotes /> },
  { path: "/notes/new", component: <AddNotes /> },

  // Profile Pages
  { path: "/userprofile", component: <UserProfile /> },
  { path: "/accounts", component: <Accounts /> },

  // Admin Pages
  { path: "/admin", component: <MoonBase /> },
  { path: "/admin/users/:id", component: <Users /> },
  { path: "/admin/clients/:id", component: <Clients /> },

  // Miscellaneous Pages
  { path: "/contact", component: <Contact /> },
  { path: "/selectAccount", component: <SelectAccount /> },
  { path: "/importXls", component: <ImportXls /> },
  { path: "/report", component: <PdfReport /> },
  { path: "/export", component: <Export /> },
  { path: "/addFile", component: <AddFile /> },
  { path: "/addFile/:id", component: <AddFile /> },

  { path: "/editFile/:id", component: <EditFile /> },



  // Catch-All Redirect (must be last)
  { 
    path: "/", 
    exact: true, 
    component: <Navigate to="/home" />, // Redirect to home page if no other route is matched
  },
];

/*
 * Define public routes that do not require authentication
 * These routes are accessible to all users, including unauthenticated users
 */
const publicRoutes = [
  // Authentication Pages
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <MoondanceLogin /> },
  { path: "/forgot-password", component: <MoondanceLostPassword /> },
  { path: "/reset-password/:code", component: <MoondanceResetPassword /> },
  { path: "/register", component: <MoondanceRegister /> },
  { path: "/confirm-signup/:token", component: <ConfirmSignup /> },
  { path: "/publicContact", component: <PublicContactForm /> },
  
  // Public Website Pages
  { path: "/home", component: <PublicWebsite /> },

  { path: "/home/services", component: <PublicServices /> },
  { path: "/confirm_contact_form/:token", component: <ConfirmContactForm /> },
  { path: "/generalSalesConditions", component: <GeneralSalesConditions /> },
  
];

export { authProtectedRoutes, publicRoutes };
